import React, {Component} from 'react';
import {
    Modal,
    Input,
    Upload,
    Form,
    Select,
    InputNumber
} from "antd";
import {localization} from '../Localization'
import {LoadingOutlined, CloudUploadOutlined} from '@ant-design/icons';

const {Option} = Select;
const {TextArea} = Input;

export const CreateShopModalForm = ({
    visible,
    language,
    onSubmit,
    onCancel,
    imageUploadUrl,
    onUpload,
    isUploadWaiting
}) => {
    const [form] = Form.useForm();
    const formItemLayout = {
        labelCol: {
            xs: {
                span: 24
            },
            sm: {
                span: 8
            }
        },
        wrapperCol: {
            xs: {
                span: 24
            },
            sm: {
                span: 12
            }
        }
    };
    const uploadButton = (
        <div>
        {isUploadWaiting?<LoadingOutlined />:<CloudUploadOutlined />}
            <div className="ant-upload-text">Upload</div>
        </div>
    );
    return (
        <Modal
            title={localization()[language].createNewData}
            visible={visible}
            centered
            okText="Submit"
            afterClose={() => {
            console.log('afterclose');
            form.resetFields();
        }}
            onCancel={() => {
            form.resetFields();
            onCancel('create')
        }}
            onOk={() => {
            form
                .validateFields()
                .then(values => {
                    values.picUrl = imageUploadUrl
                    onSubmit(values);
                })
                .catch(info => {
                    console.log('Validate Failed:', info);
                });
        }}>
            <Form {...formItemLayout} form={form}>
                <Form.Item
                    label={localization()[language].placeName}
                    name="name"
                    rules={[{
                        required: true,
                        message: localization()[language].missingValuesTxt
                    }
                ]}>
                    <Input/>
                </Form.Item>
                <Form.Item
                    label={localization()[language].staffName}
                    name="staffName"
                    rules={[{
                        required: true,
                        message: localization()[language].missingValuesTxt
                    }
                ]}>
                    <Input/>
                </Form.Item>
                <Form.Item
                    label={localization()[language].phone}
                    name="phone"
                    rules={[{
                        required: true,
                        message: localization()[language].missingValuesTxt
                    }
                ]}>
                    <Input/>
                </Form.Item>
                <Form.Item
                    label={localization()[language].type}
                    name="type"
                    rules={[{
                        required: true,
                        message: localization()[language].missingValuesTxt
                    }
                ]}>
                    <Select>
                        <Option value={0}>{localization()[language].normalHospital}</Option>
                        <Option value={1}>{localization()[language].militaryHospital}</Option>
                        <Option value={2}>{localization()[language].fieldHospital}</Option>
                        <Option value={3}>{localization()[language].ci}</Option>
                        <Option value={4}>{localization()[language].hi}</Option>
                        <Option value={5}>{localization()[language].hospitel}</Option>
                    </Select>
                </Form.Item>
                <Form.Item
                    label={localization()[language].capacity}
                    name="capacity"
                    rules={[{
                        required: true,
                        message: localization()[language].missingValuesTxt
                    }
                ]}>
                    <InputNumber/>
                </Form.Item>
                <Form.Item
                    label={localization()[language].available}
                    name="available"
                    rules={[{
                        required: true,
                        message: localization()[language].missingValuesTxt
                    }
                ]}>
                    <InputNumber/>
                </Form.Item>
                <Form.Item label={localization()[language].detail} name="detail">
                    <TextArea rows={4}/>
                </Form.Item>
                <Form.Item label={localization()[language].picUrl} name="picUrl">
                    <Upload
                        name="avatar"
                        listType="picture-card"
                        className="avatar-uploader"
                        showUploadList={false}
                        action='https://2d4a3afed51e91497e4985f5c1d6c2c6.m.pipedream.net'
                        onChange={(info) => {
                        onUpload(info)
                    }}>
                        {imageUploadUrl
                            ? <img
                                    src={imageUploadUrl}
                                    alt="avatar"
                                    style={{
                                    width: '100%'
                                }}/>
                            : uploadButton}
                    </Upload>

                </Form.Item>
            </Form>
        </Modal>
    )
}